import { render, staticRenderFns } from "./wage.vue?vue&type=template&id=486a4fca&scoped=true"
import script from "./wage.vue?vue&type=script&lang=js"
export * from "./wage.vue?vue&type=script&lang=js"
import style0 from "./wage.vue?vue&type=style&index=0&id=486a4fca&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486a4fca",
  null
  
)

export default component.exports